//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/ChartPPR";
import axios, { CancelToken } from "axios";
export default {
  components: {
    chartOTP
  },
  data() {
    return {
      refreshComponent: false,
      G1: true,
      G2: true,
      G3: true,
      G4: true,
      VN: true,
      ps: "",
      pe: "",
      red01: "[Y]",
      red02: "[Y]",
      red03: "[Y]",
      red04: "[Y]",
      red05: "[Y]",
      red06: "[Y|N]",
      red07: "[Y|N]",
      customer: "",
      customers: [],
      brand: "",
      brands: []
    };
  },

  async mounted() {
    let a = await this.defaultPeriod();
    let b = await this.listcustomer();
    let c = await this.listbrand();
    this.loadData();
  },
  methods: {
    defaultPeriod() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board1/perform/defaultweek`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.ps = res.data.ps;
        this.pe = res.data.pe;
      });

      return obj;
    },
    listcustomer() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board1/perform/customer`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.customers = res.data;
      });

      return obj;
    },
    listbrand() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board1/perform/brand`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.brands = res.data;
      });

      return obj;
    },
    loadData() {
      this.refreshComponent = false;
      this.pulling = setTimeout(() => {
        this.refreshComponent = true;
      }, 1000);
    }
  }
};
